<template>
	<div class="header-weather">
		<div class="header-item">
			<img class="item-icon" src="../../assets/image/icon_address.png">
			<span class="item-content address">南宁</span>
		</div>

<!--		<div class="header-item">-->
<!--			<img v-if="weather.icon" class="weather-icon" :src="weather.icon" />-->
<!--			<span class="weather-text">{{weather.text}} {{weather.temperature}}°C</span>-->
<!--		</div>-->
	</div>
</template>

<script>
export default {
	data(){
		return {
			weather: {
				icon: '',
				code: '',
				temperature: '',
				text: ''
			}
		}
	},
	mounted() {
	},
	methods: {
	}
}
</script>

<style scoped lang="scss">
.header-weather{
	height: 75px;
	display: flex;
	flex-direction: row;
	align-items: center;
}
.header-item{
	margin-right: 70px;
	display: flex;
	flex-direction: row;
	align-items: center;
	&:last-child{
		margin-right: 0;
	}
	.item-icon{
		width: 36px;
		height: 36px;
		margin-right: 10px;
	}
	.item-content{
		font-size: 28px;
		color: #B4E4FF;
		&.address{
			font-size: 36px;
			font-family: "screen", serif;
		}
	}
	.weather-icon{
		height: 26px;
		margin-right: 20px;
	}
	.weather-text{
		font-size: 28px;
		color: #B4E4FF;
	}
}
</style>
